import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService } from '../loader/loader.service';
import { Observable, finalize } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class HttpService {

  constructor(private http: HttpClient,
    private loader: LoaderService,
  ) { }

  get httpOptions() {
    return {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      })
    };
  }

  private buildOptions(extraHeaders?: { [header: string]: string }) {
    if (!extraHeaders) return this.httpOptions;

    let headers = this.httpOptions.headers;
    Object.keys(extraHeaders).forEach(key => {
      headers = headers.set(key, extraHeaders[key]);
    });

    return { headers };
  }

  post(url: string, payload: any, extraHeaders?: { [header: string]: string }): Observable<any> {
    return this.http.post(url, payload, this.buildOptions(extraHeaders));
  }

  put(url: string, payload: any, extraHeaders?: { [header: string]: string }): Observable<any> {
    return this.http.put(url, payload, this.buildOptions(extraHeaders));
  }

  get(url: string, id?: any, showLoader: boolean = true): Observable<any> {
    if (showLoader) this.loader.show();

    return this.http.get(url, this.httpOptions).pipe(
      finalize(() => {
        if (showLoader) this.loader.hide();
      })
    );
  }

  getById(url: string, id?: string): Observable<any> {
    return this.http.get(url, this.httpOptions);
  }

  delete(url: string, id: any): Observable<any> {
    return this.http.delete(url, this.httpOptions);
  }

}